module.exports = __webpack_public_path__ + "static/media/sidebar-2.f93bd626.jpg";